module.exports = TextEncoder;


//////////////////
// WEBPACK FOOTER
// external "TextEncoder"
// module id = 44
// module chunks = 0